import { render, staticRenderFns } from "./CrearTicket.vue?vue&type=template&id=364908d8&scoped=true&"
import script from "./CrearTicket.vue?vue&type=script&lang=js&"
export * from "./CrearTicket.vue?vue&type=script&lang=js&"
import style0 from "./CrearTicket.vue?vue&type=style&index=0&id=364908d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364908d8",
  null
  
)

export default component.exports